module.exports = __webpack_public_path__ + "assets/img/back-cbc72021.png";